<template>
    <div class="container">
      <!--b-card :title="$t('yearly_expense_summary')" :class="isRtleft ? 'text-end' : 'text-start'"-->
      <h2>{{ $t('titre.YearlyExpenses') }}</h2>
        
        <!-- Year Selection -->
        <div class="d-flex mb-3">
          <select v-model="selectedYear" class="form-control" @change="fetchMonthlyExpenses">
            <option v-for="year in availableYears" :key="year" :value="year">{{ year }}</option>
          </select>
        </div>
  
        <!-- Table Displaying Monthly Expenses -->
        <div class="card">
          <table class="custom-table">
            <thead>
              <tr>
                <th>{{ $t('month') }}</th>
                <th>{{ $t('total_expenses') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in monthlyExpenses" :key="index">
                <td>{{ months[item.month - 1] }}</td>
                <td>{{ formatPrice(item.totalAmount) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td><strong>{{ $t('total') }}</strong></td>
                <td><strong>{{ formatPrice(totalYearAmount) }}</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
    </div>
  </template>
  
  <script>
  import { MonthlyExpensesService } from "../api"; // You might need to update this to match your actual API
  import { Message } from "../libjs/alertService";
  
  export default {
    data() {
      return {
        availableYears: Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i),
        selectedYear: new Date().getFullYear(),
        months: [
          this.$t("months.january"), this.$t("months.february"), this.$t("months.march"), this.$t("months.april"),
          this.$t("months.may"), this.$t("months.june"), this.$t("months.july"), this.$t("months.august"),
          this.$t("months.september"), this.$t("months.october"), this.$t("months.november"), this.$t("months.december")
        ],
        monthlyExpenses: [],
      };
    },
    computed: {
      totalYearAmount() {
        return this.monthlyExpenses.reduce((sum, item) => sum + item.totalAmount, 0);
      },
      isRtleft() {
        return this.$i18n.locale === "ar";
      },
    },
    methods: {
      async fetchMonthlyExpenses() {
        try {
          const response = await MonthlyExpensesService.getYearlyExpenseByYear(this.selectedYear);
          this.monthlyExpenses = response.map(item => ({
            month: item[1], // month
            totalAmount: item[2], // totalAmount
          }));
        } catch (error) {
          console.error("Error fetching monthly expenses:", error);
          Message("danger", this.$t("message.operation_failed"));
        }
      },
      formatPrice(value) {
        if (!value) return "0 €";
        return new Intl.NumberFormat("es-ES", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2
        }).format(value);
      },
    },
    mounted() {
      this.fetchMonthlyExpenses();
    },
  };
  </script>
  
  <style scoped>

  
.container {
    margin-top: 20px;
    border: 1px solid #ddd;
    padding: 0px;
    border-radius: 10px;
  }

  h2 {
    background-color: #47c399;
    border-radius: 10px 10px 0 0;
    color: azure;
    padding: 3px;
    text-align: justify;
    padding-left: 15px;
  }
  /* Table Styling */
  .custom-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    margin-top: 20px;
  }
  
  .custom-table thead tr {
    background-color: #f2f2f2;
  }
  
  .custom-table th, .custom-table td {
    border: 1px solid #ddd;
    padding: 6px;
    text-align: center;
  }
  
  /* Footer Row Styling */
  .custom-table tfoot tr {
    background-color: #f2f2f2;
  }
  
  .custom-table tfoot td {
    font-weight: bold;
    text-align: right;
  }
  </style>
  